// src/components/Muestras/PrintEtiqueta.jsx
import React, { forwardRef } from "react";
import { Typography } from "@mui/material";

const PrintEtiqueta = forwardRef(({ muestra }, ref) => {
  if (!muestra) return null;

  return (
    <div
      ref={ref}
      style={{
        width: "40mm",
        height: "30mm",
        padding: "2mm",
        boxSizing: "border-box",
        border: "1px dashed #ccc",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fff",
      }}
    >
      {/*   <div>
        <img src={logo} alt="Logo" style={{ width: "60px" }} />
      </div> */}

      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {muestra.QR_CODE && (
          <img
            src={muestra.QR_CODE}
            alt="QR"
            style={{ width: "20mm", height: "20mm", objectFit: "contain" }}
          />
        )}
        <Typography
          variant="subtitle2"
          style={{
            fontWeight: 700,
            marginTop: "1mm",
            fontSize: "3mm",
            lineHeight: 1.1,
          }}
        >
          {muestra.MUESTRA}
        </Typography>
        {/*  <Typography variant="caption">{muestra.NombreCliente}</Typography> */}
      </div>
    </div>
  );
});

PrintEtiqueta.displayName = "PrintEtiqueta";

export default PrintEtiqueta;
